import { Controller } from '@hotwired/stimulus'
import { DispatchEvent } from '../types'
import { targetUpdate } from './components/component_controller'

export class ServiceOfferingFormController extends Controller {
  static targets = ['siteSelect']

  declare readonly siteSelectTarget: HTMLSelectElement

  async handleLocationSelectionEvent(event: DispatchEvent<{ value: string }>) {
    const locationId = event.detail.value
    const response = await fetch(`/locations/${locationId}/sites.json`)
    const sites = await response.json()
    this.updateOptions(sites)
  }

  private updateOptions(options: { label: string; value: string }[]) {
    const formattedOptions = options.map((option) => ({
      label: option.label,
      value: option.value,
    }))
    targetUpdate(this.siteSelectTarget, {
      options: formattedOptions,
      value: '',
    })
    this.siteSelectTarget.dispatchEvent(new Event('change'))
  }
}
